window.grabAndMoreExpand = function (parentSelector, gridSelector) {
    const section = document.querySelector(parentSelector);
    const grid = section && section.querySelector(gridSelector);
    const button = section && section.querySelector('.grab-top-section-and-more')
    if (grid) {
        computedStyle = window.getComputedStyle(grid);
        // getComputedStyle で取り出すと 'repeat(3, 1fr)' ではなく '360px, 360px, 360px' となっている。
        const matcher = computedStyle.gridTemplateColumns.match(/repeat\s*\(\s*(\d+)\s*,/);
        const cols = matcher ? parseInt(matcher[1]) : computedStyle.gridTemplateColumns.split(' ').length;
// console.log('computedStyle.gridTemplateColumns', computedStyle.gridTemplateColumns)
// console.log('matcher', matcher)
// console.log('cols', cols)
        const cards = Array.from(grid.children);
        let invisibleCards = [];
        cards.forEach(card => {
            if (card.offsetWidth === 0) {
                invisibleCards.push(card);
            }
        });
        if (invisibleCards.length === 0) {
            button.style.display = 'none';
        }
        else {
            button.addEventListener('click', () => {
                for (let i = 0; i < cols && i < invisibleCards.length; i++) {
                    invisibleCards[i].style.display = 'block';
                }
                if (invisibleCards.length > cols) {
                    button.style.display = 'block';
                    invisibleCards.splice(0, cols);
                }
                else {
                    invisibleCards = []
                    button.style.display = 'none';
                }
            });
        }
    }
}